export default "__VITE_ASSET__B6KM0o6f__"